const Partners = () => {
    return (
        <>
            <div className="hidden lg:block ">
                <ul className="inline-flex flex-wrap justify-center w-full">
                    <li >
                        <a className="items-center cursor-pointer flex h-[50px] justify-center w-[110px] m-[10px] [transition:filter_0.2s_ease-out,_-webkit-filter_0.2s_ease-out]" href="#">
                            <img src="/assets/images/evolution.png" alt="Evolution" /></a>
                    </li>
                    <li >
                        <a className="items-center cursor-pointer flex h-[50px] justify-center w-[110px] m-[10px] [transition:filter_0.2s_ease-out,_-webkit-filter_0.2s_ease-out]" href="#">
                            <img src="/assets/images/ezugi.png" alt="Ezugi" />
                        </a>
                    </li>
                    <li >
                        <a className="items-center cursor-pointer flex h-[50px] justify-center w-[110px] m-[10px] [transition:filter_0.2s_ease-out,_-webkit-filter_0.2s_ease-out]" href="#">
                            <img src="/assets/images/pragmatic-live.png" alt="Pragmatic Live"></img>
                        </a>
                    </li>
                    <li >
                        <a className="items-center cursor-pointer flex h-[50px] justify-center w-[110px] m-[10px] [transition:filter_0.2s_ease-out,_-webkit-filter_0.2s_ease-out]" href="#">
                            <img src="/assets/images/betgames.png" alt="Betgames"></img>
                        </a>
                    </li>
                    <li >
                        <a className="items-center cursor-pointer flex h-[50px] justify-center w-[110px] m-[10px] [transition:filter_0.2s_ease-out,_-webkit-filter_0.2s_ease-out]" href="#">
                            <img src="/assets/images/ssg.png" className='h-full' alt="Super Spade Games"></img>
                        </a>
                    </li>
                    <li >
                        <a className="items-center cursor-pointer flex h-[50px] justify-center w-[110px] m-[10px] [transition:filter_0.2s_ease-out,_-webkit-filter_0.2s_ease-out]" href="#">
                            <img src="/assets/images/betsoft.png" alt="Betsoft"></img>
                        </a>
                    </li>
                    <li >
                        <a className="items-center cursor-pointer flex h-[50px] justify-center w-[110px] m-[10px] [transition:filter_0.2s_ease-out,_-webkit-filter_0.2s_ease-out]" href="#">
                            <img src="/assets/images/spribe.png" alt="Spribe"></img>
                        </a>
                    </li>
                    <li >
                        <a className="items-center cursor-pointer flex h-[50px] justify-center w-[110px] m-[10px] [transition:filter_0.2s_ease-out,_-webkit-filter_0.2s_ease-out]" href="#">
                            <img src="/assets/images/Evoplay.png" alt="Evoplay"></img>
                        </a>
                    </li>
                    <li >
                        <a className="items-center cursor-pointer flex h-[50px] justify-center w-[110px] m-[10px] [transition:filter_0.2s_ease-out,_-webkit-filter_0.2s_ease-out]" href="#">
                            <img src="/assets/images/logo-18plus.svg" alt="+18"></img>
                        </a>
                    </li>
                </ul>
                <div className="text-[#fff] font-[Poppins,_sans-serif] text-[10px] font-semibold pb-[3px] text-center">You must be over 18 years old, or the legal age at which gambling or gaming activities are allowed under the law or jurisdiction that applies to you. You must reside in a country in which access to online gambling to its residents.</div>
            </div>
            <div className="block lg:hidden">
                <ul className="inline-flex flex-wrap justify-center w-full">
                    <li>
                        <a className="h-auto m-[5px] w-[60px] items-center cursor-pointer flex justify-center" href="#">
                            <img className="my-[10px] mx-[3px]" src="/assets/svg/evolution.svg" alt="Evolution" />
                        </a>
                    </li>
                    <li>
                        <a className="h-auto m-[5px] w-[60px] items-center cursor-pointer flex justify-center" href="#">
                            <img className="my-[10px] mx-[3px]" src="/assets/svg/ezugi.svg" alt="Ezugi"></img>
                        </a>
                    </li>
                    <li>
                        <a className="h-auto m-[5px] w-[60px] items-center cursor-pointer flex justify-center" href="#">
                            <img className="my-[10px] mx-[3px]" src="/assets/svg/pragmatic.svg" alt="Pragmatic Live"></img>
                        </a>
                    </li>
                    <li>
                        <a className="h-auto m-[5px] w-[60px] items-center cursor-pointer flex justify-center" href="#">
                            <img className="my-[10px] mx-[3px]" src="/assets/svg/betgames.svg" alt="Betgames"></img>
                        </a>
                    </li>
                    <li>
                        <a className="h-auto m-[5px] w-[60px] items-center cursor-pointer flex justify-center" href="#">
                            <img className="my-[10px] mx-[3px]" src="/assets/svg/superspade.svg" alt="Super Spade Games"></img>
                        </a>
                    </li>
                    <li>
                        <a className="h-auto m-[5px] w-[60px] items-center cursor-pointer flex justify-center" href="#">
                            <img className="my-[10px] mx-[3px]" src="/assets/svg/betsoft.svg" alt="Betsoft"></img>
                        </a>
                    </li>
                    <li>
                        <a className="h-auto m-[5px] w-[60px] items-center cursor-pointer flex justify-center" href="#">
                            <img className="my-[10px] mx-[3px]" src="/assets/svg/spribe.svg" alt="Spribe"></img>
                        </a>
                    </li>
                    <li>
                        <a className="h-auto m-[5px] w-[60px] items-center cursor-pointer flex justify-center" href="#">
                            <img className="my-[10px] mx-[3px]" src="/assets/svg/evoplay.svg" alt="Evoplay"></img>
                        </a>
                    </li>
                    <li>
                        <a className="h-auto m-[5px] w-[60px] items-center cursor-pointer flex justify-center" href="#">
                            <img className="my-[10px] mx-[3px]" src="/assets/svg/logo-18plus.svg" alt="+18"></img>
                        </a>
                    </li>
                </ul>
                <div className="text-[#000] text-[10px] font-semibold pb-[3px] text-center">You must be over 18 years old, or the legal age at which gambling or gaming activities are allowed under the law or jurisdiction that applies to you. You must reside in a country in which access to online gambling to its residents.</div>
            </div>
        </>
    )
}
export default Partners;
